import { Component } from '@angular/core';
import { EnumScales } from '@library/store/measures/measures.interface';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { LangPipe } from '@library/utils/pipes/lang.pipe';
import { EnergyReportsFacade } from '@store/energy-reports/energy-reports.facade';
import { combineLatest, map } from 'rxjs';
import { CpReportsScaleService } from '../cp-reports-scale-selector/cp-reports-scale.service';

@Component({
  selector: 'app-cp-reports-hours-saved',
  templateUrl: './cp-reports-hours-saved.component.html',
  styleUrls: ['./cp-reports-hours-saved.component.scss']
})
export class CpReportsHoursSavedComponent {
  report$ = this.energyReportsFacade.currentReport$.pipe(isDefined());

  hoursSaved$ = combineLatest([
    this.report$,
    this.cpReportsScaleService.scale$
  ]).pipe(
    map(([report, scale]) => {
      const heatingTimePrevious = scale === EnumScales.YEAR ? report.total_heating_time_previous_year : report.total_heating_time_previous_month;
      if(typeof report.total_heating_time === 'undefined' || typeof heatingTimePrevious === 'undefined') {
        return null;
      }
      else {
        return Math.round((report.total_heating_time - heatingTimePrevious ) / 3600);
      }
    })
  );

  hoursSavedPercent$ =  combineLatest([
    this.report$,
    this.cpReportsScaleService.scale$
  ]).pipe(
    map(([report, scale]) => {
      const heatingTimePrevious = scale === EnumScales.YEAR ? report.total_heating_time_previous_year : report.total_heating_time_previous_month;
      if (!report.total_heating_time || !heatingTimePrevious || report.total_heating_time < 3600 || heatingTimePrevious < 3600 ) {
        return 0;
      }
      else {
        return Math.round(
          ((report.total_heating_time - heatingTimePrevious  ) / heatingTimePrevious ) * 100);
      }
    })
  );

  viewModel$ = combineLatest({
    hoursSaved: this.hoursSaved$,
    hoursSavedPercent: this.hoursSavedPercent$,
    report$: this.report$
  });

  constructor(
    private energyReportsFacade: EnergyReportsFacade,
    private cpReportsScaleService: CpReportsScaleService,
    private langPipe: LangPipe,
  ) {}

  getHours(hoursSaved: number) {
    if (hoursSaved) {
      return hoursSaved > 0 ? '+' + hoursSaved + ' ' +this.langPipe.transform('common-settings.__HOURS'): hoursSaved + ' ' + this.langPipe.transform('common-settings.__HOURS');
    }
    else {
      return this.langPipe.transform('common-app.__NO_DATA');
    }
  }
}
